const Loading = () => {
  return (
    <div className="loading">
      <img src="/favicon.png" alt="Favicon" /> Loading
    </div>
  );
};

export default Loading;